/**
 * Client-supplied analytics context helpers.
 *
 * - experimentBucket: a deterministic control/treatment split derived from the stable anon id.
 *
 * Geo (city/region/country) is no longer client-supplied — it is derived server-side from
 * load-balancer edge headers.
 */

import { readAnonIdSync } from './anon-id'

/**
 * Deterministic 50/50 A/B split derived from the anon id (djb2 hash → parity).
 * Persists nothing extra; stable for the lifetime of the anon id. Returns undefined if no
 * anon id is available yet (event still emits, just without a bucket).
 */
export function getExperimentBucket(): 'control' | 'treatment' | undefined {
  const anonId = readAnonIdSync()
  if (!anonId) {
    return undefined
  }
  let hash = 5381
  for (let i = 0; i < anonId.length; i++) {
    hash = (hash * 33) ^ anonId.charCodeAt(i)
  }
  // >>> 0 forces unsigned; parity gives an even ~50/50 split.
  return (hash >>> 0) % 2 === 0 ? 'control' : 'treatment'
}
